/* global femcare, addeventatc */

femcare.form.periodTracker = {

    init: function () {
        if ($('.period-tracker').length) {
            var datepickerLoaded = !!$.fn.datepicker;

            if (datepickerLoaded) {
                this.prepareSections();
            } else {
                var assetsPath = femcare.shared.util.getAssetsPath();
                $.getScript(assetsPath + '/js/datepicker.js', function () {
                    this.prepareSections();
                }.bind(this));
            }
        }
    },

    prepareSections: function () {
        this.addToCalendarInit();
        this.getPeriodTrackerScript();
    },

    addToCalendarInit: function () {
        window.addeventasync = function () {
            addeventatc.settings({
                appleical: { show: true, text: 'Apple Calendar' },
                google: { show: true, text: 'Google <em>(online)</em>' },
                outlook: { show: true, text: 'Outlook' },
                outlookcom: { show: false, text: 'Outlook.com <em>(online)</em>' },
                yahoo: { show: false, text: 'Yahoo <em>(online)</em>' }
            });
        };
    },

    getPeriodTrackerScript: function () {
        var assetsPath = femcare.shared.util.getAssetsPath();
        $.getScript(assetsPath + '/js/period-tracker.js');
    },
};
